import React, { useEffect, useState } from 'react';
import { Route, Routes, BrowserRouter, useSearchParams, useNavigate } from "react-router-dom";
import Home from "./views/Home";
import Layout from "./layouts/Layout";
import SelectGame from "./views/SelectGame";
import DailyCheckin from "./views/DailyCheckin";
import DailyTasks from "./views/DailyTasks";
import DailyGamingTasks from "./views/DailyGamingTasks";
import EslOrignals from "./views/EslOrignals";
import Highlights from "./views/Highlights";
import WeeklyTournaments from "./views/WeeklyTournaments";
import Rewards from "./views/Rewards";
import WeeklyTournamentJoin from "./views/WeeklyTournamentJoin";
import EslTournamentJoin from "./views/EslTournamentJoin";
import GameChallenges from "./views/GameChallenges";
import { authenticateUser, isAuthenticated, getActiveDayData, updateActiveDay } from './api/auth';
import { getUserProfile } from './api/profile';
import Leaderboard from "./views/Leaderboard";
import CompletedTasks from "./views/CompletedTasks";
import Notifications from "./views/Notifications";
import GameHighlights from "./views/GameHighlights";
import Profile from "./views/Profile";
import EditProfile from "./views/EditProfile";
import FAQs from "./views/FAQs";
import Unsubscribe from "./views/Unsubscribe";
import LearnWin from './views/LearnWin';
import GoogleAnalyticsConditional from './components/GoogleAnalyticsConditional';
import RedeemForm from './views/RedeemForm';
import Thankyou from './views/Thankyou';
import PrivacyPolicy from './views/Terms';
import AimTrain from './views/Games/AimTrain';
import CannonClash2D from './views/Games/CannonClash2D';
import PuzzleRotate from './views/Games/PuzzleRotate';
import TournamentDetails from './views/TournamentDetails';
import SpaceFootball from './views/Games/SpaceFootball';
import EonDash from './views/Games/EonDash';
import AimTrainStg from './views/Games/AimTrain_stg';
import { jwtDecode } from 'jwt-decode';
import PremiumUpgrade from './views/PremiumUpgrade';
import Permissions from './views/Permissions';

const fetchActiveDay = async (setShowGameSelector, setShowDailyCheckin) => {
  try {
    if (isAuthenticated()) {

      const activeDayData = await getActiveDayData();

      if (activeDayData) {
        sessionStorage.setItem("activeDayData", JSON.stringify(activeDayData));
        sessionStorage.setItem('activeDay', activeDayData.active_streak);
        sessionStorage.setItem('gameId', activeDayData.gameId);

        const gameSelectorShown = sessionStorage.getItem('gameSelectorShown');
        const dailyCheckinShown = sessionStorage.getItem('dailyCheckinShown');
        {
          if (!dailyCheckinShown) {
            setShowDailyCheckin(true);
            sessionStorage.setItem('dailyCheckinShown', 'true');
          }
        }

        if (!activeDayData.gameId) {
          if (!gameSelectorShown) {
            sessionStorage.setItem('activeDay', JSON.stringify(activeDayData.active_day));
            setShowGameSelector(true);
            sessionStorage.setItem('gameSelectorShown', 'true');
          }
        }
      }
    }
  } catch (error) {
  }
};

const MsisdnCheck = ({ setShowGameSelector, setShowDailyCheckin }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate()
  useEffect(() => {
    const checkAuth = async () => {
      let msisdn = sessionStorage.getItem('msisdn');
      let refferer = searchParams.get('refferer') || sessionStorage.getItem('refferer') || searchParams.get('referer');
      let authResult;
      if (refferer && (refferer === "gamenow")) {
        sessionStorage.setItem('gamesNowRef', true);
      }
      if (!msisdn) {
        msisdn = searchParams.get('a');
        if (msisdn) {
          if (refferer === "gamenow" || refferer === "inhouse") {
            authResult = await authenticateUser(msisdn, refferer);
          } else {
            authResult = await authenticateUser(msisdn, null);
          }
          if (!authResult.success) {
            redirectToLogin();
          } else {
            window.dispatchEvent(new CustomEvent('authComplete'));
            await fetchActiveDay(setShowGameSelector, setShowDailyCheckin);
          }
        } else {
          redirectToLogin();
        }
      } else if (!isAuthenticated()) {
        const authResult = await authenticateUser(msisdn, refferer);
        if (!authResult.success) {
          redirectToLogin();
        } else {
          window.dispatchEvent(new CustomEvent('authComplete'));
          await fetchActiveDay(setShowGameSelector, setShowDailyCheckin);
        }
      } else {
        await fetchActiveDay(setShowGameSelector, setShowDailyCheckin);
      }

      const rew = searchParams.get('r');
      if (rew) {
        if (rew == 1) {
          setShowDailyCheckin(false)
          setShowGameSelector(false)
          navigate('/rewards')
        }
      }
    };

    const redirectToLogin = () => {
      const loginUrl = process.env.REACT_APP_LOGIN_URL;
      if (window.location.pathname === '/tasks' || window.location.pathname === '/join-tournament' || window.location.pathname === '/redeem' || window.location.pathname == "/profile") {
        if (sessionStorage.getItem("gamesNowRef") != 'true')
          window.location.href = loginUrl;
      }
    };

    checkAuth();
  }, [searchParams, setShowGameSelector, setShowDailyCheckin]);

  return null;
};

const getIsJcUser = () => {
  const accessToken = sessionStorage.getItem('access_token');
  if (!accessToken) return false;

  try {
    const decoded = jwtDecode(accessToken);
    return String(decoded?.is_premium) === '1';
  } catch {
    return false;
  }
};

function App() {
  const [showGameSelector, setShowGameSelector] = useState(false);
  const [showDailyCheckin, setShowDailyCheckin] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [isJcUser, setIsJcUser] = useState(getIsJcUser);

  useEffect(() => {
    const fetchProfile = async () => {
      if (isAuthenticated()) {
        try {
          const response = await getUserProfile();
          if (response.success) {
            setProfileData(response);
            sessionStorage.setItem('profileData', JSON.stringify(response));
          }
        } catch (error) {
        }
      }
    };

    fetchProfile();
    window.addEventListener('authComplete', fetchProfile);

    return () => window.removeEventListener('authComplete', fetchProfile);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const value = getIsJcUser();
      setIsJcUser(prev => (prev === value ? prev : value));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const handleCloseGameSelector = () => {
    setShowGameSelector(false);
  };

  const handleCloseDailyCheckin = () => {
    const activeDayData = JSON.parse(sessionStorage.getItem('activeDayData'));
    setShowDailyCheckin(false);
    if (!activeDayData.gameId) {
      setShowGameSelector(true);
    }
  };

  return (
    <div>

      <BrowserRouter>
        <MsisdnCheck
          setShowGameSelector={setShowGameSelector}
          setShowDailyCheckin={setShowDailyCheckin}
        />
        {/* <GoogleAnalyticsConditional
          trackingId="G-ZLE6YPN01C"  //  JAZZ ESL ID for the login page
        /> */}
        <Layout profileData={profileData}>
          <Routes>
            <Route path="/" element={<Home isJcUser={isJcUser} />} />
            <Route path="/tasks" element={<DailyTasks />} />
            <Route path="/daily-gaming-tasks" element={<DailyGamingTasks isJcUser={isJcUser} />} />
            <Route path="/esl-orignals" element={<EslOrignals isJcUser={isJcUser} />} />
            <Route path="/game-challenges" element={<GameChallenges />} />
            <Route path="/highlights" element={<Highlights />} />
            <Route path='/game-highlights' element={<GameHighlights />} />
            <Route path="/tournaments" element={<WeeklyTournaments isJcUser={isJcUser} />} />
            <Route path="/join-tournament" element={<WeeklyTournamentJoin isJcUser={isJcUser} />} />
            <Route path="/join-esl-tournament" element={<EslTournamentJoin />} />
            <Route path="/rewards" element={<Rewards isJcUser={isJcUser} />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/completed" element={<CompletedTasks />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/profile" element={<Profile isJcUser={isJcUser} />} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/permissions" element={<Permissions />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/learn-win" element={<LearnWin />} />
            <Route path='/redeem' element={<RedeemForm />} />
            <Route path='/thankyou' element={<Thankyou />} />
            <Route path='/terms-service' element={<PrivacyPolicy />} />
            <Route path='/aim-train' element={<AimTrain />} />
            <Route path='/premium-plan' element={<PremiumUpgrade />} />
            {/* <Route path='/aim-train-stg' element={<AimTrainStg />} /> */}
            <Route path='cannon-clash' element={<CannonClash2D />} />
            <Route path='/puzzle-mania' element={<PuzzleRotate />} />
            <Route path='/space-football' element={<SpaceFootball />} />
            {/* <Route path='/eon-dash' element={<EonDash />} /> */}
            <Route path='/tournament/:tournamentId' element={<TournamentDetails />} />
          </Routes>
        </Layout>
        {showGameSelector && <SelectGame isOpen={showGameSelector} onClose={handleCloseGameSelector} />}
        {showDailyCheckin && <DailyCheckin isOpen={showDailyCheckin} onClose={handleCloseDailyCheckin} />}
      </BrowserRouter>
    </div>
  );
}

export default App;